<template>
  <div id="Main" style="">
    <div class="main-contant" id="MainContent" style="bottom: 80px">
      <!-- 图片 -->
      <div class="img-container">
        <!-- 水印图片 -->
        <img id="top-icon" src="../../assets/images/y2wm/topIcon.png" alt="" style="" />
        <!-- 产品图片 -->
        <div style="background: #fff; border-radius: 9px; text-align: center; padding: 16px;">
          <img id="cover" :src="topImgPath" alt="" style="width: 40%;" />
        </div>

      </div>
      <!-- 产品信息 -->
      <div class="productcard">
        <div class="product-title">基本信息</div>
        <!-- 根据页面数据数量调整产品信息显示模式 -->
        <!-- 显示模式1 -->
        <div class="product-content" id="product-wrap" style="display: none">
          <div class="cardinfotitle">
            <div class="cardinfotitle-title">品规：</div>
            <div class="cardinfotitle-info" id="brandName">中国名烟</div>
          </div>
          <div class="cardinfotitle">
            <div class="cardinfotitle-title">品规所属企业：</div>
            <div class="cardinfotitle-info" id="corpName">
              ##中烟工业有限责任公司
            </div>
          </div>

          <!-- 卷烟数据显示 -->
          <div id="product-wrap-cigarette" style="display: none">
            <div class="cardinfotitle">
              <div class="cardinfotitle-float" style="width: 55%">
                <div class="cardinfotitle-title">烟气一氧化碳：</div>
                <div class="cardinfotitle-info" id="carbonicOxide">11 mg</div>
              </div>
              <div class="cardinfotitle-float" style="width: 45%">
                <div class="cardinfotitle-title">类&nbsp;&nbsp;&nbsp;型：</div>
                <div class="cardinfotitle-info" id="typeName">烤烟型</div>
              </div>
            </div>
            <div class="cardinfotitle">
              <div class="cardinfotitle-float" style="width: 55%">
                <div class="cardinfotitle-title">烟气烟碱量：</div>
                <div class="cardinfotitle-info" id="alkaliName">0.8 mg</div>
              </div>
              <div class="cardinfotitle-float" style="width: 45%">
                <div class="cardinfotitle-title">焦油量：</div>
                <div class="cardinfotitle-info" id="tarName">9 mg</div>
              </div>
            </div>
          </div>
          <!-- 雪茄烟数据显示 -->
          <div id="product-wrap-cigar" style="display: none">
            <div class="cardinfotitle">
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">焦油量：</div>
                <div class="cardinfotitle-info" id="cigarTarName">8</div>
              </div>
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">环径：</div>
                <div class="cardinfotitle-info" id="cigarRingDiameterName"></div>
              </div>
            </div>
            <div class="cardinfotitle">
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">烟支长度：</div>
                <div class="cardinfotitle-info" id="cigarLengthName"></div>
              </div>
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">烟支周长：</div>
                <div class="cardinfotitle-info" id="cigarPerimeterName"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 显示模式2 -->
        <div class="product-content-spacing" id="product-wrap-spacing" style="">
          <div class="cardinfotitle">
            <div class="cardinfotitle-title">品规：</div>
            <div class="cardinfotitle-info" id="brandName-spacing">
              中国名烟
            </div>
          </div>
          <div class="cardinfotitle">
            <div class="cardinfotitle-title">品规所属企业：</div>
            <div class="cardinfotitle-info" id="corpName-spacing">
              ##中烟工业有限责任公司
            </div>
          </div>

          <!-- 卷烟数据显示 -->
          <div class="cardinfotitle">
            <div class="cardinfotitle-float" style="width: 55%">
              <div class="cardinfotitle-title">烟气一氧化碳：</div>
              <div class="cardinfotitle-info" id="carbonicOxide-spacing">
                6 mg
              </div>
            </div>
            <div class="cardinfotitle-float" style="width: 45%">
              <div class="cardinfotitle-title">类&nbsp;&nbsp;&nbsp;型：</div>
              <div class="cardinfotitle-info" id="typeName-spacing">烤烟型</div>
            </div>
          </div>
          <div class="cardinfotitle last-child">
            <div class="cardinfotitle-float" style="width: 55%">
              <div class="cardinfotitle-title">烟气烟碱量：</div>
              <div class="cardinfotitle-info" id="alkaliName-spacing">
                0.8 mg
              </div>
            </div>
            <div class="cardinfotitle-float" style="width: 45%">
              <div class="cardinfotitle-title">焦油量：</div>
              <div class="cardinfotitle-info" id="tarName-spacing">8 mg</div>
            </div>
          </div>

          <!-- 雪茄烟数据显示 -->
          <div id="product-wrap-spacing-cigar" style="display: none">
            <div class="cardinfotitle">
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">焦油量：</div>
                <div class="cardinfotitle-info" id="cigarTarName-spacing">
                  8
                </div>
              </div>
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">环径：</div>
                <div class="cardinfotitle-info" id="cigarRingDiameterName-spacing"></div>
              </div>
            </div>
            <div class="cardinfotitle">
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">烟支长度：</div>
                <div class="cardinfotitle-info" id="cigarLengthName-spacing"></div>
              </div>
              <div class="cardinfotitle-float" style="width: 50%">
                <div class="cardinfotitle-title">烟支周长：</div>
                <div class="cardinfotitle-info" id="cigarPerimeterName-spacing"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 全国市场监管服务热线 -->
      <div class="productcard">
        <div class="product-title">全国市场监管服务热线</div>
        <div class="normal-content">
          <div class="normal-info">
            <a href="tel:12313" style="color: #0c7eea">12313</a>
          </div>
        </div>
      </div>
      <div id="custom-wrap" class="productcard">
        <div id="custom-title" class="product-title">企业服务热线</div>
        <div class="normal-content">
          <div class="normal-info">
            <a href="tel:4008668866" style="color: #0c7eea">4008668866</a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" id="enterprise-services" style="">
      <div class="button" @click="auth()">企业服务</div>
      <!-- <div class="button" @click="auth()">验真服务</div> -->
      <div class="button">评价建议</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      webpath: "/prod-api/common/wx/signature",
      topImgPath: "./static/images/zgmy.png",
      toUrl: "",
      yhs: ['']
    }
  },
  created() {
    // setTimeout(() => {
    //   this.initTocken();
    // }, 1000);
    console.log(this.$router.history)
    if (['/kjza', '/kjzb', '/kjzc', '/lby'].find(item => this.$route.query._u.includes(item))) {
      this.topImgPath = './static/images/zgmy.png'
      // this.toUrl = "http://y3wm.cn/kjza/0"
    }
    else if (['/fqb', '/lbr'].find(item => this.$route.query._u.includes(item))) {
      this.topImgPath = './static/images/zgmy2.png'
      // this.toUrl = "http://y3wm.cn/kjzb/0"
    }
    else if (['/qya', '/qyb'].find(item => this.$route.query._u.includes(item))) {
      this.topImgPath = './static/images/zgmy3.png'
      // this.toUrl = "http://y3wm.cn/kjzc/0"
    }
  },
  methods: {
    jumpToOther() {
      this.$router.push({ path: '/main', query: { pageId: 881, url: '' } })
    },
    auth() {
      // if (this.toUrl)
      this.$router.push({ path: '/main', query: this.$route.query })
      // else {
      //   wx.ready(function () {
      //     console.log('wxsuccess');
      //     wx.scanQRCode({
      //       needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      //       scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      //       success: function (res) {
      //         let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
      //         window.location.href = result
      //       }
      //     });
      //   });
      //   wx.error(function (res) {
      //     console.error(res)
      //   });
      // }
    },
    initTocken: function () {
      var that = this;
      $.ajax({
        type: "get",
        url: that.webpath,
        async: false,
        cache: false,
        timeout: 60000,
        scriptCharset: "utf-8",
        data: { url: location.href },
        success: function (sign) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: sign.appid, // 必填，公众号的唯一标识
            timestamp: sign.timestamp, // 必填，生成签名的时间戳
            nonceStr: sign.noncestr, // 必填，生成签名的随机串
            signature: sign.signature,// 必填，签名，见附录1
            jsApiList: ['getLocation', 'chooseImage', 'uploadImage', 'previewImage', 'downloadImage', 'scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        },
        error: function (err) {
          console.log(err)
        }
      });
    }
  }
}
</script>
<style scoped>
html,
body {
  background-color: #f6f6f6;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

#app {
  box-sizing: border-box;
}

#Main {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

#Err {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  padding-top: 10px;
}

#Main .title,
#Err .title {
  padding: 13px 0px;
  background-color: #0c7eea;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  line-height: bold;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
}

#Main .main-contant {
  padding: 15px;
  padding-top: 10px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  height: auto;
  /* è®¾ç½®80px */
  bottom: 80px;
}

#Main .img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-top: 20px;
}

#Main .img-container #top-icon {
  width: 90px;
  left: 38px;
  top: 44px;
  position: absolute;
}

#Main .img-container img {
  width: 100%;
  border-radius: 9px;
}

#Main .productcard {
  margin-top: 20px;
  box-sizing: border-box;
}

#Main .productcard .product-title {
  font-size: 18px;
  font-weight: 500;
  color: #0c7eea;
  position: relative;
  padding-left: 7px;
}

#Main .productcard .product-title::before {
  content: '';
  position: absolute;
  left: 0;
  width: 3px;
  height: 18px;
  background: #0c7eea;
  border-radius: 3px;
}

#Main .productcard .product-content {
  box-sizing: border-box;
  margin-top: 20px;
  padding: 0 10px 0 10px;
  background: #ffffff;
  border-radius: 9px;
  width: 100%;
  height: 100%;
}

#Main .productcard .product-content .cardinfotitle {
  border-bottom: 1px solid #dfdfdf;
  display: flex;
}

#Main .productcard .product-content .cardinfotitle .cardinfotitle-title {
  font-size: 16px;
  line-height: 17px;
  padding: 19px 0 19px 0;
  color: #333;
  white-space: nowrap;
  animation: scroll-text 5s linear infinite;
  /* è®¾ç½®åŠ¨ç”» */
}

#Main .productcard .product-content .cardinfotitle .cardinfotitle-info {
  font-size: 16px;
  line-height: 17px;
  padding-top: 19px;
  color: #666666;
  word-break: break-all;
}

#Main .productcard .product-content .cardinfotitle .cardinfotitle-float {
  /* width: 50%; */
  display: flex;
}

#Main .productcard .product-content-spacing {
  box-sizing: border-box;
  margin-top: 20px;
  width: 100%;
  height: 100%;
}

#Main .productcard .product-content-spacing .cardinfotitle {
  background-color: #fff;
  /* border-radius: 9px; */
  padding: 0 10px 0 10px;
  border-bottom: 1px solid #ccc;
  /* margin-top: 15px; */
  display: flex;
}

#Main .productcard .product-content .cardinfotitle:first-child {
  padding-top: 0;
  /* border-radius: 9px; */
}

#Main .productcard .product-content .cardinfotitle:last-child {
  padding-bottom: 0;
  border: none;
}

.last-child {
  padding-bottom: 0;
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 9px;
  border: none;
}

#Main .productcard .product-content-spacing .cardinfotitle .cardinfotitle-title {
  font-size: 16px;
  line-height: 17px;
  padding: 24px 0 24px 0;
  color: #333;
  white-space: nowrap;
}

#Main .productcard .product-content-spacing .cardinfotitle .cardinfotitle-info {
  font-size: 16px;
  line-height: 17px;
  padding-top: 24px;
  color: #666666;
  word-break: break-all;
}

#Main .productcard .product-content-spacing .cardinfotitle .cardinfotitle-float {
  /* width: 50%; */
  display: flex;
}

#Main .productcard .product-content-spacing .cardinfotitle:first-child {
  padding-top: 0;

  border-top-right-radius: 9px;
  border-top-left-radius: 9px;
}

#Main .productcard .product-content-spacing .cardinfotitle:last-child {
  padding-bottom: 0;
  border: none;

  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 9px;
}

#Main .productcard .normal-content {
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  border-radius: 9px;
  height: 60px;
  width: 100%;
}

#Main .productcard .normal-content .normal-info {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 100%;
  line-height: 60px;
  font-size: 16px;
  color: #0c7eea;
  font-weight: 400;
}

#Main .footer {
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 80px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8888;
}

#Main .footer .button {
  background: #0c7eea;
  border-radius: 40px;
  min-width: 106px;
  height: 38px;
  line-height: 38px;
  margin-top: 20px;
  color: #fff;
  font-weight: 700;
  font-size: .43rem;
  text-align: center;
}

#Err .content {
  width: 100%;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#Err .content img {
  width: 100%;
  height: auto;
}

#Err .content .scan-error-msg {
  margin-top: 50px;
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

#Err .content .scan-error-msg-1 {
  margin-top: 15px;
  font-size: 15px;
  color: #666666;
}

#Err .footer {
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
}

#Err .footer .close {
  width: 170px;
  padding: 10px 0px;
  background: #0c7eea;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
  border-radius: 8px;
}

#privacyModal {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  z-index: 9999;
}

#privacyModal .modal-wrap {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
}

#privacyModal .modal-wrap .modal-content {
  position: absolute;
  bottom: 0;
  height: 80%;
  background-color: #ffffff;
  border-radius: 34px 34px 0px 0px;
  border: 8px solid #0c7eea;
  border-bottom: 0;
}

#privacyModal .modal-wrap .modal-content #modal-icon {
  width: 180px;
  height: 38.5px;
  position: absolute;
  top: -24px;
  left: calc(50% - 90px);
}

#privacyModal .modal-wrap .modal-content .modal-text {
  width: 100%;
  height: calc(100% - 100px);
  margin-top: 20px;
  box-sizing: border-box;
  padding: 0 20px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #666666;
  text-align: justify;
  word-break: break-all;
  overflow-y: scroll;
}

#privacyModal .modal-wrap .modal-content .modal-action {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

#privacyModal .modal-wrap .modal-content .modal-action .cancel-button {
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 41px;
  border: 1px solid #0c7eea;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 18px;
  color: #0c7eea;
}

#privacyModal .modal-wrap .modal-content .modal-action .confirm-button {
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #0c7eea;
  border-radius: 41px;
  border: 1px solid #0c7eea;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
}

a {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/y2wm/index.vue